import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { Radio } from "antd";
import type { RadioChangeEvent } from "antd";
import { Col, DatePicker, Row } from "antd";
import dayjs from "dayjs";
import { NumberParam, useQueryParams } from "use-query-params";
import type { Dayjs } from "dayjs";
import { Dropdown, Form, Modal, message } from "antd";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import SettingsIcon from "@mui/icons-material/Settings";
import type { TableProps } from "antd/es/table";
import {
  AlignCenterOutlined,
  AppstoreOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { Skeleton } from "antd";
import TextArea from "antd/es/input/TextArea";
import type { MenuProps } from "antd";
import type { FilterValue, SorterResult } from "antd/es/table/interface";
import Highlighter from "react-highlight-words";
import type { InputRef } from "antd";
import { Button, Input, Space, Table } from "antd";
import type { ColumnType, ColumnsType } from "antd/es/table";
import type { FilterConfirmProps } from "antd/es/table/interface";
import {} from "@mui/x-data-grid";

import axios from "axios";

import Globais, {
  formatarData,
  enviarEmail,
  validateToken,
  validatePeriodoFracionado,
  adicionarDiasData,
  AlterarFormatoData,
  CalcularDiferencaDias,
} from "../../components/Globais";

import MenuItem from "@mui/material/MenuItem";
import ModalMostrarPreco from "../../components/ModalMostrarPreco";
import { blue } from "@mui/material/colors";
import { cadastrarReserva } from "../../services/cadastrarReserva";

const Container = styled.section`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template: 10% 90% / 100%;
`;
const ContainerFiltro = styled.section`
  width: 100%;
  height: 100%;
  display: flex;

  justify-content: center;
  align-items: center;
`;
const ContainerLista = styled.section`
  width: 100%;
  height: 100%;
  display: grid;
  min-width: 20rem;
  overflow: auto;
  padding: 1rem;
  grid-template: 10% 90% / auto;
`;

const BotoesAcoes = styled.button`
  border: none;
  color: blue;
  background-color: transparent;
  &: hover {
    cursor: pointer;
  }
`;

interface DataType {
  id: number;
  idPEU: number;
  idUs: number;
  nomeUs: string;
  sobrenome: string;
  celular: string;
  email: string;
  nomeEP: string;
  numeroCota: number;
  checked: string;
  checkIn: string;
  checkOut: string;
  divulgado: string;
  origem: number;
  valorMin: string;

  updated_at: Date;
  active: string;
  fracionamento: number;
  situacao: string;
  periodoId: number;
  periodoUsuarioId: number;
  dataEspecial: string;
  idPE: number;
  idCTU: number;
}

interface Values {
  title: string;
  description: string;
}
interface ValuesValor {
  valorMin: string;
}
interface ValuesFracao {
  checkIn1: string;
  checkOut1: string;
  valorMin1: string;
  checkIn2: string;
  checkOut2: string;
  valorMin2: string;
}

interface CollectionCreateFormProps {
  open: boolean;
  onCreate: (values: Values) => void;
  onCancel: () => void;
}
interface CollectionCreateFormPropsValor {
  open: boolean;
  onCreate: (valuesValor: ValuesValor) => void;
  onCancel: () => void;
}
interface CollectionCreateFormPropsFracao {
  open: boolean;
  onCreate: (valuesFracao: ValuesFracao) => void;
  onCancel: () => void;
}

export function exibirMoeda(valor: string) {
  let valorNovo;

  if (valor == undefined) {
    console.log("Não tem valor");
    return "";
  } else {
    let valorPreparado = valor.replace(",", ".");
    valorNovo = new Intl.NumberFormat("pt-BR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
      .format(+valorPreparado)
      .toString();
  }

  return valorNovo;
}

type DataIndex = keyof DataType;

type MenuItem = Required<MenuProps>["items"][number];

export default function ViewGerenciarPropriedades() {
  const [Aluguel, setAluguel] = useState<any>();

  const [nNumeroCota, setNNumeroCota] = useQueryParams({
    numeroCota: NumberParam,
  });
  const [nCotaUsuarioId, setNCotaUsuarioId] = useQueryParams({
    cotaUsuarioId: NumberParam,
  });

  const valor = useRef("");
  const emLote = useRef(0);
  const fracionamento = useRef(0);
  const cotaUsuarioId = useRef(0);
  const alugarOuTrocar = useRef(0);
  const checkInPeriodo = useRef("");
  const checkOutPeriodo = useRef("");
  const nomeEP = useRef("");
  const checkInPrimeiroPeriodo = useRef("");
  const checkOutPrimeiroPeriodo = useRef("");
  const checkInSegundoPeriodo = useRef("");
  const checkOutSegundoPeriodo = useRef("");
  const periodoUsuario = useRef(0);
  const periodo = useRef(0);
  const situacao = useRef("Alugar");
  const divulgado = useRef("");
  const [openValor, setOpenValor] = useState(false);
  const [openFracao, setOpenFracao] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [sugestaoCheckOut, setSugestaoCheckOut] = useState("");
  const [openExcluir, setOpenExcluir] = useState(false);
  const [openValores, setOpenValores] = useState(false);
  const [open, setOpen] = useState(false);
  const [openError, setOpenError] = useState(false);
  const periodoUsuarioId = periodoUsuario.current;
  const { RangePicker } = DatePicker;
  const dateFormat = "DD/MM/YYYY";
  const active = useRef("");
  const nome = useRef("");
  const userId = useRef(0);
  const [messageApi, contextHolder] = message.useMessage();
  const [value, setValue] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef<InputRef>(null);
  const [IsModalMostrarPrecoVisible, setIsModalMostrarPrecoVisible] =
    useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const [filteredInfo, setFilteredInfo] = useState<
    Record<string, FilterValue | null>
  >({});
  const [sortedInfo, setSortedInfo] = useState<SorterResult<DataType>>({});

  const percentualComissaoEtaxasEStays = 0.7014;

  const excluirPeriodo = async () => {
    const Token = validateToken();

    const periodoUsuarioId = periodoUsuario.current;

    if (Token) {
      const URL = `${Globais.DOMINIOBACK}/periodo-usuario/${periodoUsuarioId}`;

      try {
        const response = await axios.delete(URL, {
          headers: { Authorization: Token.AuthStr },
        });
        if (response) {
          success("Período excluído com sucesso!");
          setTimeout(() => {
            document.location.reload();
          }, 2000);
        } else {
          error("Algo deu errado!");
        }
      } catch (error) {
        error("Algo deu errado!");
      }
    } else {
      document.location.href = "/";
    }
  };
  const onRangeChangePrimeiroPeriodo = (
    dates: null | (Dayjs | null)[],
    dateStrings: string[]
  ) => {
    if (dates) {
      if (
        validatePeriodoFracionado(
          checkInPeriodo.current,
          checkOutPeriodo.current,
          dateStrings[0],
          dateStrings[1],
          "",
          ""
        ) === "ok"
      ) {
        checkInPrimeiroPeriodo.current = dateStrings[0];
        checkOutPrimeiroPeriodo.current = dateStrings[1];
        setSugestaoCheckOut(dateStrings[1]);
      } else {
        error(
          validatePeriodoFracionado(
            checkInPeriodo.current,
            checkOutPeriodo.current,
            dateStrings[0],
            dateStrings[1],
            "",
            ""
          )
        );
      }
    }
  };

  const onRangeChangeSegundoPeriodo = (
    dates: null | (Dayjs | null)[],
    dateStrings: string[]
  ) => {
    if (dates) {
      if (
        validatePeriodoFracionado(
          checkInPeriodo.current,
          checkOutPeriodo.current,
          "",
          "",
          dateStrings[0],
          dateStrings[1]
        )
      ) {
        checkInSegundoPeriodo.current = dateStrings[0];
        checkOutSegundoPeriodo.current = dateStrings[1];
        setSugestaoCheckOut(dateStrings[0]);
      } else {
        error(
          validatePeriodoFracionado(
            checkInPeriodo.current,
            checkOutPeriodo.current,
            "",
            "",
            dateStrings[0],
            dateStrings[1]
          )
        );
      }
    }

    // console.log(new Date("2023-11-23") > new Date(date3));
  };

  const atualizarValorAluguel = async (periodoUsuarioId: any, tipo: number) => {
    const Token = validateToken();

    const valorMin = valor.current;
    if (tipo === 1) {
      if (Token) {
        const URL = `${Globais.DOMINIOBACK}/periodo-usuario/${periodoUsuarioId}`;
        let formData = {
          alugar: 1,
          trocar: 0,
          concluido: 0,
          utilizar: 0,
          valorMin: valorMin,
        };
        ////

        try {
          const response = await axios.put(URL, formData, {
            headers: { Authorization: Token.AuthStr },
          });
          if (response) {
            success("Período atualizado com sucesso!");
            setTimeout(() => {
              document.location.reload();
            }, 2000);
          } else {
            error("Algo deu errado!");
          }
        } catch (error) {
          error("Algo deu errado!");
        }
      } else {
        document.location.href = "/";
      }
    } else {
      if (tipo === 2) {
        if (Token) {
          const URL = `${Globais.DOMINIOBACK}/periodo-usuario/${periodoUsuarioId}`;
          let formData = {
            alugar: 1,
            trocar: 1,
            concluido: 0,
            utilizar: 0,
            valorMin: valorMin,
          };
          ////

          try {
            const response = await axios.put(URL, formData, {
              headers: { Authorization: Token.AuthStr },
            });
            if (response) {
              success("Período atualizado com sucesso!");
              setTimeout(() => {
                document.location.reload();
              }, 2000);
            } else {
              error("Algo deu errado!");
            }
          } catch (error) {
            error("Algo deu errado!");
          }
        } else {
          document.location.href = "/";
        }
      }
    }
  };
  const hideModal = () => {
    setOpenExcluir(false);
  };
  const CollectionCreateForm: React.FC<CollectionCreateFormProps> = ({
    open,
    onCreate,
    onCancel,
  }) => {
    const [form] = Form.useForm();
    return (
      <Modal
        open={open}
        title="Mandar E-mail"
        okText="Enviar"
        cancelText="Cancelar"
        onCancel={onCancel}
        onOk={() => {
          form
            .validateFields()
            .then((values) => {
              form.resetFields();
              onCreate(values);
            })
            .catch((info) => {
              console.log("Validate Failed:", info);
            });
        }}
      >
        <Form
          form={form}
          layout="vertical"
          name="form_in_modal"
          // initialValues={{ modifier: "public" }}
        >
          <Form.Item
            name="title"
            label="Assunto"
            rules={[
              { required: true, message: "Por favor insira um assunto!" },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="description"
            label="Mensagem"
            rules={[
              { required: true, message: "Por favor insira uma mensagem!" },
            ]}
          >
            <TextArea size="large" autoSize={{ minRows: 2, maxRows: 6 }} />
          </Form.Item>
          {/* <Form.Item
            name="modifier"
            className="collection-create-form_last-form-item"
          ></Form.Item> */}
        </Form>
      </Modal>
    );
  };

  const CollectionCreateFormValor: React.FC<CollectionCreateFormPropsValor> = ({
    open,
    onCreate,
    onCancel,
  }) => {
    const [form] = Form.useForm();
    return (
      <Modal
        open={openValor}
        title="Incluir valor do aluguel"
        okText="Incluir"
        cancelText="Cancelar"
        onCancel={onCancel}
        onOk={() => {
          form
            .validateFields()
            .then((valuesValor) => {
              form.resetFields();
              onCreate(valuesValor);
            })
            .catch((info) => {
              console.log("Validate Failed:", info);
            });
        }}
      >
        <Form
          form={form}
          layout="vertical"
          // name="form_in_modal"
          initialValues={{ modifier: "public" }}
        >
          <Form.Item
            name="valorMin"
            label="Valor"
            rules={[{ required: true, message: "Por favor insira um valor!" }]}
          >
            <TextArea size="small" autoSize={{ minRows: 2, maxRows: 2 }} />
          </Form.Item>
          {/* <Form.Item
            name="modifier"
            className="collection-create-form_last-form-item"
          ></Form.Item> */}
        </Form>
      </Modal>
    );
  };

  const CollectionCreateFormFracao: React.FC<
    CollectionCreateFormPropsFracao
  > = ({ open, onCreate, onCancel }) => {
    const [form] = Form.useForm();
    return (
      <Modal
        open={openFracao}
        title="Fracionar período"
        okText="Fracionar"
        cancelText="Cancelar"
        onCancel={onCancel}
        onOk={() => {
          form
            .validateFields()
            .then((valuesFracao) => {
              form.resetFields();
              onCreate(valuesFracao);
            })
            .catch((info) => {
              console.log("Validate Failed:", info);
            });
        }}
      >
        <Form
          form={form}
          layout="vertical"
          // name="form_in_modal"
          // initialValues={{ modifier: "public" }}
        >
          <Row gutter={16}>
            <Col span={16}>
              <Form.Item
                name="periodo1"
                label="Primeiro período"
                // {...{ wrapperCol: { span: 9, offset: 2 } }}
              >
                <RangePicker
                  placeholder={["check-in", "check-out"]}
                  format={dateFormat}
                  size={"large"}
                  onChange={onRangeChangePrimeiroPeriodo}
                  defaultValue={[
                    dayjs(checkInPeriodo.current, dateFormat),
                    dayjs(sugestaoCheckOut, dateFormat),
                  ]}
                  disabled={[true, false]}
                />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                name="valorMin1"
                label="Valor"
                rules={[
                  { required: true, message: "Por favor insira um valor!" },
                ]}
              >
                <TextArea size="small" autoSize={{ minRows: 2, maxRows: 2 }} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={16}>
              <Form.Item
                name="periodo2"
                label="Segundo período"
                // {...{ wrapperCol: { span: 9, offset: 2 } }}
              >
                <RangePicker
                  placeholder={["check-in", "check-out"]}
                  format={dateFormat}
                  size={"large"}
                  onChange={onRangeChangeSegundoPeriodo}
                  defaultValue={[
                    dayjs(sugestaoCheckOut, dateFormat),
                    dayjs(checkOutPeriodo.current, dateFormat),
                  ]}
                  disabled={[false, true]}
                />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                name="valorMin2"
                label="Valor"
                rules={[
                  { required: true, message: "Por favor insira um valor!" },
                ]}
              >
                <TextArea size="small" autoSize={{ minRows: 2, maxRows: 2 }} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  };
  const CollectionCreateFormValores: React.FC<
    CollectionCreateFormPropsFracao
  > = ({ open, onCreate, onCancel }) => {
    const [form] = Form.useForm();

    const dias = CalcularDiferencaDias(
      AlterarFormatoData(checkOutPeriodo.current),
      AlterarFormatoData(checkInPeriodo.current)
    );

    let novoValor = parseInt(valor.current.replace(".", ""));

    const diaria = novoValor / dias;

    const diariaExibida = `R$ ${exibirMoeda((novoValor / dias).toString())}`;

    const valorDiariaAjustada = diaria * (1 + 0.181);

    const valorDiariaAjustadaExibida = `R$ ${exibirMoeda(
      valorDiariaAjustada.toString()
    )}`;

    const airbnb = novoValor * (1 + 0.3641);
    const diariaairbnb = airbnb / dias;

    const booking = novoValor * (1 + 0.3381);
    const diariabooking = booking / dias;

    const decolar = novoValor * (1 + 0.3641);
    const diariadecolar = decolar / dias;

    const expedia = novoValor * (1 + 0.4172);
    const diariaexpedia = expedia / dias;

    const onChange = (e: RadioChangeEvent) => {
      console.log("radio checked", e.target.value);
      setValue(e.target.value);
    };

    return (
      <Modal
        open={openValores}
        title="Valores"
        okText="Ok"
        cancelText="Cancelar"
        onCancel={onCancel}
        onOk={onCancel}
      >
        <Form form={form} layout="vertical">
          <Row gutter={16}>
            <Col style={{ alignItems: "center" }} span={8}>
              <p>Valor Cotista</p>
              <p>{`R$ ${valor.current}`}</p>
            </Col>

            <Col
              style={{ alignItems: "center", justifyContent: "center" }}
              span={4}
            >
              <p>Qtd Dias</p>
              <p
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >{`${dias}`}</p>
            </Col>
            <Col
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
              span={12}
            >
              <p>Valor a ser colocado na stays</p>
              <p>{`${valorDiariaAjustadaExibida}`}</p>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={20}>
              <p>Valor Diária</p>
              <p>{` ${diariaExibida}`}</p>
            </Col>
            <Col span={4}></Col>
          </Row>
          <Row
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
            gutter={17}
          >
            <Radio.Group onChange={onChange} value={value}>
              <Radio value={1}>Airbnb</Radio>
              <Radio value={2}>Booking</Radio>
              <Radio value={3}>Decolar</Radio>
              <Radio value={4}>Expedia</Radio>
            </Radio.Group>
          </Row>
          <Row gutter={16}>
            {value === 1 ? (
              <>
                <Col span={2}></Col>
                <Col
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  span={11}
                >
                  <p>Valor Airbnb</p>
                  <p>{`R$ ${exibirMoeda(airbnb.toString())}`}</p>
                </Col>
                <Col
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  span={6}
                >
                  <p>Diária Airbnb</p>
                  <p>{`R$ ${exibirMoeda(diariaairbnb.toString())}`}</p>
                </Col>
                <Col span={6}></Col>
              </>
            ) : value === 2 ? (
              <>
                <Col
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  span={12}
                >
                  <p>Valor Booking</p>
                  <p>{`R$ ${exibirMoeda(booking.toString())}`}</p>
                </Col>
                <Col
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  span={10}
                >
                  <p>Diária Booking</p>
                  <p>{`R$ ${exibirMoeda(diariabooking.toString())}`}</p>
                </Col>
              </>
            ) : value === 3 ? (
              <>
                <Col
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  span={12}
                >
                  <p>Valor Decolar</p>
                  <p>{`R$ ${exibirMoeda(decolar.toString())}`}</p>
                </Col>
                <Col
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  span={10}
                >
                  <p>Diária Decolar</p>
                  <p>{`R$ ${exibirMoeda(diariadecolar.toString())}`}</p>
                </Col>
              </>
            ) : value === 4 ? (
              <>
                <Col
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  span={12}
                >
                  <p>Valor Expedia </p>
                  <p>{`R$ ${exibirMoeda(expedia.toString())}`}</p>
                </Col>
                <Col
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  span={10}
                >
                  <p>Diária Expedia</p>
                  <p>{`R$ ${exibirMoeda(diariaexpedia.toString())}`}</p>
                </Col>
              </>
            ) : null}
          </Row>
        </Form>
      </Modal>
    );
  };

  const atualizarValorAluguelEmLote = async (
    periodoUsuarioId: any,
    tipo: number
  ) => {
    const Token = validateToken();

    const valorMin = valor.current;
    if (tipo === 1) {
      let formData = {
        alugar: 1,
        trocar: 0,
        concluido: 0,
        utilizar: 0,
        valorMin: valorMin,
      };

      if (Token) {
        for (let i = 0; i < selectedRowKeys.length; i++) {
          const URL = `${Globais.DOMINIOBACK}/periodo-usuario/${selectedRowKeys[i]}`;

          try {
            const response = await axios.put(URL, formData, {
              headers: { Authorization: Token.AuthStr },
            });
            if (response) {
              if (i === selectedRowKeys.length - 1) {
                success("Períodos atualizados com sucesso!");
                setTimeout(() => {
                  document.location.reload();
                }, 2000);
              }
            } else {
              error("Algo deu errado!");
            }
          } catch (error) {
            error("Algo deu errado!");
          }
        }
      }
    } else {
      if (tipo === 2) {
        let formData = {
          alugar: 1,
          trocar: 1,
          concluido: 0,
          utilizar: 0,
          valorMin: valorMin,
        };
        if (Token) {
          for (let i = 0; i < selectedRowKeys.length; i++) {
            const URL = `${Globais.DOMINIOBACK}/periodo-usuario/${selectedRowKeys[i]}`;

            try {
              const response = await axios.put(URL, formData, {
                headers: { Authorization: Token.AuthStr },
              });
              if (response) {
                if (i === selectedRowKeys.length - 1) {
                  success("Períodos atualizados com sucesso!");
                  setTimeout(() => {
                    document.location.reload();
                  }, 2000);
                }
              } else {
                error("Algo deu errado!");
              }
            } catch (error) {
              error("Algo deu errado!");
            }
          }
        }
      }
    }
  };

  const warning = (texto: string) => {
    messageApi.open({
      type: "warning",
      content: texto,
    });
  };

  const clearFilters = () => {
    setFilteredInfo({});
  };

  const clearAll = () => {
    setFilteredInfo({});
    setSortedInfo({});
  };

  function getItem(
    label: React.ReactNode,
    key: React.Key,
    icon?: React.ReactNode,
    children?: MenuItem[],
    type?: "group"
  ): MenuItem {
    return {
      key,
      icon,
      children,
      label,
      type,
    } as MenuItem;
  }

  const success = (texto: string) => {
    messageApi.open({
      type: "success",
      content: texto,
    });
  };

  const showModal = () => {
    setOpenExcluir(true);
  };

  const error = (texto: string) => {
    messageApi.open({
      type: "error",
      content: texto,
    });
  };

  const onClick: MenuProps["onClick"] = async ({ key }) => {
    const Token = validateToken();
    const perfil = Token?.nda;
    const periodoUsuarioId = periodoUsuario.current;
    const periodoId = periodo.current;
    const situacaoAtual = situacao.current;
    const divulgadoAtual = divulgado.current;
    if (
      periodoUsuarioId === 0 &&
      selectedRowKeys.length === 0 &&
      emLote.current === 1
    ) {
      error("Selecione um item!");
    } else {
      switch (key) {
        case "1":
          if (periodoUsuarioId === 0 && emLote.current === 1) {
            error("Essa funcionalidade só pode ser feita um por um.");
          } else {
            if (situacaoAtual === "Não definido") {
              error("A situação já está como não definida.");
            } else {
              if (divulgadoAtual === "Sim") {
                error(
                  "Esse período está sendo divulgado antes de alterar a situação retire o anúncio."
                );
              } else {
                if (Token) {
                  const URL = `${Globais.DOMINIOBACK}/periodo-usuario/${periodoUsuarioId}`;

                  let formData = {
                    alugar: 0,
                    trocar: 0,
                    utilizar: 0,
                    concluido: 0,
                    divulgado: 0,
                  };
                  ////

                  try {
                    const response = await axios.put(URL, formData, {
                      headers: { Authorization: Token.AuthStr },
                    });
                    if (response) {
                      success("Período atualizado com sucesso!");
                      setTimeout(() => {
                        document.location.reload();
                      }, 2000);
                    } else {
                      error("Algo deu errado!");
                    }
                  } catch (error) {
                    error("Algo deu errado!");
                  }
                } else {
                  document.location.href = "/";
                }
              }
            }
          }
          break;
        case "2":
          if (periodoUsuarioId === 0 && emLote.current === 1) {
            alugarOuTrocar.current = 1;
            setOpenValor(true);
          } else {
            if (situacaoAtual === "Alugar") {
              error("A situação já está como alugar.");
            } else {
              alugarOuTrocar.current = 1;
              setOpenValor(true);
            }
          }

          break;
        case "3":
          if (periodoUsuarioId === 0 && emLote.current === 1) {
            error("Essa funcionalidade só pode ser feita um por um.");
          } else {
            if (situacaoAtual === "Trocar") {
              error("A situação já está como trocar.");
            } else {
              if (divulgadoAtual === "Sim") {
                error(
                  "Esse período está sendo divulgado antes de alterar a situação retire o anúncio."
                );
              } else {
                if (Token) {
                  const URL = `${Globais.DOMINIOBACK}/periodo-usuario/${periodoUsuarioId}`;
                  let formData = {
                    alugar: 0,
                    trocar: 1,
                    utilizar: 0,
                    concluido: 0,
                    divulgado: 0,
                  };
                  ////

                  try {
                    const response = await axios.put(URL, formData, {
                      headers: { Authorization: Token.AuthStr },
                    });
                    if (response) {
                      success("Período atualizado com sucesso!");
                      setTimeout(() => {
                        document.location.reload();
                      }, 2000);
                    } else {
                      error("Algo deu errado!");
                    }
                  } catch (error) {
                    error("Algo deu errado!");
                  }
                } else {
                  document.location.href = "/";
                }
              }
            }
          }

          break;

        case "4":
          if (periodoUsuarioId === 0 && emLote.current === 1) {
            alugarOuTrocar.current = 2;
            setOpenValor(true);
          } else {
            if (situacaoAtual === "Alugar ou trocar") {
              error("A situação já está como alugar ou trocar.");
            } else {
              alugarOuTrocar.current = 2;
              setOpenValor(true);
            }
          }

          break;

        case "5":
          if (periodoUsuarioId === 0 && emLote.current === 1) {
            error("Essa funcionalidade só pode ser feita um por um.");
          } else {
            if (situacaoAtual === "Será utilizado") {
              error("A situação já está como 'Será utilizado'.");
            } else {
              if (divulgadoAtual === "Sim") {
                error(
                  "Esse período está sendo divulgado antes de alterar a situação retire o anúncio."
                );
              } else {
                if (Token) {
                  const URL = `${Globais.DOMINIOBACK}/periodo-usuario/${periodoUsuarioId}`;
                  let formData = {
                    alugar: 0,
                    trocar: 0,
                    utilizar: 1,
                    concluido: 0,
                    divulgado: 0,
                  };

                  try {
                    const response = await axios.put(URL, formData, {
                      headers: { Authorization: Token.AuthStr },
                    });
                    if (response) {
                      success("Período atualizado com sucesso!");
                      setTimeout(() => {
                        document.location.reload();
                      }, 2000);
                    } else {
                      error("Algo deu errado!");
                    }
                  } catch (error) {
                    error("Algo deu errado!");
                  }
                } else {
                  document.location.href = "/";
                }
              }
            }
          }

          break;
        case "6":
          if (periodoUsuarioId === 0 && emLote.current === 1) {
            error("Essa funcionalidade só pode ser feita um por um.");
          } else {
            if (situacaoAtual === "Reservado pelo próprio") {
              error("A situação já está como 'Reservado pelo próprio'.");
            } else {
              if (divulgadoAtual === "Sim") {
                error(
                  "Esse período está sendo divulgado antes de alterar a situação retire o anúncio."
                );
              } else {
                if (Token) {
                  const URL = `${Globais.DOMINIOBACK}/periodo-usuario/${periodoUsuarioId}`;
                  let formData = {
                    alugar: 0,
                    trocar: 0,
                    utilizar: 0,
                    concluido: 1,
                    divulgado: 0,
                  };

                  try {
                    const response = await axios.put(URL, formData, {
                      headers: { Authorization: Token.AuthStr },
                    });
                    if (response) {
                      success("Período atualizado com sucesso!");
                      setTimeout(() => {
                        document.location.reload();
                      }, 2000);
                    } else {
                      error("Algo deu errado!");
                    }
                  } catch (error) {
                    error("Algo deu errado!");
                  }
                } else {
                  document.location.href = "/";
                }
              }
            }
          }

          break;
        case "7":
          if (periodoUsuarioId === 0 && emLote.current === 1) {
            error("Essa funcionalidade só pode ser feita um por um.");
          } else {
            if (situacaoAtual === "Reservado por MC") {
              error("A situação já está como 'Reservado por MC'.");
            } else {
              if (divulgadoAtual === "Sim") {
                error(
                  "Esse período está sendo divulgado antes de alterar a situação retire o anúncio e depois retire a inidcação de divulgado."
                );
              } else {
                if (Token) {
                  const URL = `${Globais.DOMINIOBACK}/periodo-usuario/${periodoUsuarioId}`;
                  let formData = {
                    alugar: 0,
                    trocar: 0,
                    utilizar: 0,
                    concluido: 2,
                    divulgado: 0,
                  };

                  try {
                    const response = await axios.put(URL, formData, {
                      headers: { Authorization: Token.AuthStr },
                    });
                    if (response) {
                      const data = {
                        periodoUsuarioId: periodoUsuarioId,
                        dataReserva: new Date(),
                      };
                      const reserva = await cadastrarReserva(data);
                      if (reserva) {
                        let resposta = enviarEmail({
                          userId: userId.current,
                          tipoEmail: 21,
                          subjectEmail:
                            "Multicotas - Reserva Efetuada com Sucesso",
                          bodyEmail: "",
                          checkIn: checkInPeriodo.current,
                          checkOut: checkOutPeriodo.current,
                          empreend: nomeEP.current,
                          valor: valor.current,
                        });
                        if (await resposta) {
                          success("Período atualizado com sucesso!");
                          setTimeout(() => {
                            document.location.reload();
                          }, 2000);
                        } else {
                          error("Não foi possível enviar e-mail!");
                        }
                      } else {
                        error("Não foi possível cadastrar reserva!");
                      }
                    } else {
                      error("Não foi possível atualizar reserva!");
                    }
                  } catch (error) {
                    error("Algo deu errado3!");
                  }
                } else {
                  document.location.href = "/";
                }
              }
            }
          }

          break;
        case "8":
          if (periodoUsuarioId === 0 && emLote.current === 1) {
            error("Essa funcionalidade só pode ser feita um por um.");
          } else {
            if (divulgadoAtual === "Não") {
              error("Esse período não está sendo divulgado mesmo.");
            } else {
              if (Token) {
                const URL = `${Globais.DOMINIOBACK}/periodo-usuario/${periodoUsuarioId}`;
                let formData = {
                  divulgado: 0,
                };

                try {
                  const response = await axios.put(URL, formData, {
                    headers: { Authorization: Token.AuthStr },
                  });
                  if (response) {
                    warning(
                      "Feito. Não esqueça de retirar o anúncio do período!"
                    );

                    setTimeout(() => {
                      document.location.reload();
                    }, 2000);
                  } else {
                    error("Algo deu errado!");
                  }
                } catch (error) {
                  error("Algo deu errado!");
                }
              } else {
                document.location.href = "/";
              }
            }
          }

          break;
        case "9":
          if (periodoUsuarioId === 0 && emLote.current === 1) {
            error("Essa funcionalidade só pode ser feita um por um.");
          } else {
            if (divulgadoAtual === "Sim") {
              error("Esse período já está sendo divulgado.");
            } else {
              if (
                situacaoAtual === "Alugar" ||
                situacaoAtual === "Alugar ou trocar"
              ) {
                if (Token) {
                  const URL = `${Globais.DOMINIOBACK}/periodo-usuario/${periodoUsuario.current}`;
                  let formData = {
                    divulgado: 1,
                  };

                  try {
                    const response = await axios.put(URL, formData, {
                      headers: { Authorization: Token.AuthStr },
                    });
                    if (response) {
                      success("Período atualizado com sucesso!");
                      setTimeout(() => {
                        document.location.reload();
                      }, 2000);
                    } else {
                      error("Algo deu errado!");
                    }
                  } catch (error) {
                    error("Algo deu errado!");
                  }
                } else {
                  document.location.href = "/";
                }
              } else {
                error(
                  "Somente poderá ser divulgado os períodos que estão em situação 'Alugar' ou 'Alugar ou trocar'."
                );
              }
            }
          }
          break;
        case "10":
          if (periodoUsuarioId === 0 && emLote.current === 1) {
            error("Essa funcionalidade só pode ser feita um por um.");
          } else {
            if (divulgadoAtual === "Sim") {
              error(
                "Antes de excluir esse período deve-se retirá-lo da divulgação."
              );
            } else {
              showModal();
            }
          }

          break;
        case "11":
          if (userId.current) {
            cotaUsuarioId.current = userId.current;
            setOpen(true);
          }
          break;
        case "12":
          console.log(situacaoAtual);

          if (periodoUsuarioId === 0 && emLote.current === 1) {
            error("Essa funcionalidade só pode ser feita um por um.");
          } else {
            if (divulgadoAtual === "Sim") {
              warning(
                "Esse período está sendo divulgado. Não esqueça de alterar o valor nas plataformas."
              );
            }
            if (situacaoAtual === "Alugar") {
              alugarOuTrocar.current = 1;
              setOpenValor(true);
            }
          }

          break;
        case "13":
          //tratamento fracionamento
          if (periodoUsuarioId === 0 && emLote.current === 1) {
            error("Essa funcionalidade só pode ser feita um por um.");
          } else {
            if (fracionamento.current !== 0) {
              error("Esse já é um período fracionado.");
            } else {
              setSugestaoCheckOut(adicionarDiasData(checkInPeriodo.current, 4));
              setOpenFracao(true);
            }
          }
          break;

        case "14":
          setOpenValores(true);

          break;
      }
    }
  };
  const items: MenuProps["items"] = [
    getItem("Mudar situação", "sub2", <AppstoreOutlined />, [
      getItem("Não definido", "1"),
      getItem("Trocar", "3"),
      getItem("Alterar valor", "12"),
      getItem("Será utilizado", "5"),
      getItem("Reservado pelo próprio", "6"),
      getItem("Reservado por MC", "7"),
    ]),
    getItem("Mudar divulgação", "sub3", <AppstoreOutlined />, [
      getItem("Não divulgado", "8"),
      getItem("Divulgado", "9"),
    ]),
    { key: "10", label: "Excluir" },
    { key: "13", label: "Fracionar" },
    { key: "14", label: "Valor a ser anunciado" },
    getItem("Mandar mensagem", "sub4", <AppstoreOutlined />, [
      getItem("Genérica", "11"),
    ]),
  ];

  const handleSearch = (
    selectedKeys: string[],
    confirm: (param?: FilterConfirmProps) => void,
    dataIndex: DataIndex
  ) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters: () => void) => {
    clearFilters();
    setSearchText("");
  };

  useEffect(() => {
    const fetch = async () => {
      const Token = validateToken();
      if (Token) {
        if (Token.nda === 0) {
          document.location.href = "/sempermissao";
        } else {
          setIsLoading(false);
        }
      } else {
        document.location.href = "/login";
      }
    };
    fetch();
  }, []);

  useEffect(() => {
    const fetchToken = async () => {
      const Token = validateToken();
      const props = {};

      if (Token) {
        const URL = `${Globais.DOMINIOBACK}/periodo-usuario/alugueis/disponiveis/`;
        try {
          const response = await axios.post(URL, props, {
            headers: { Authorization: Token.AuthStr },
          });

          if (response) {
            let ArrayNovo = response.data.filter((p: any) => {
              if (p.fracionamento === 0) {
                p.key = p.idPEU;
                p.id = p.idPEU;
                p.nomeUs = `${p.nomeUs} ${p.sobrenome}`;
                p.checkIn = formatarData(p.checkIn);
                p.checkOut = formatarData(p.checkOut);
                if (p.alugar === 2) {
                  p.valorMin = "";
                } else {
                  p.valorMin = exibirMoeda(p.valorMin);
                }

                if (p.divulgado === 0) {
                  p.divulgado = "Não";
                } else {
                  if (p.divulgado === 1) {
                    p.divulgado = "Sim";
                  }
                }

                const ArrayChildren = response.data.filter((q: any) => {
                  if (q.fracionamento === p.idPEU) {
                    q.key = q.idPEU;
                    q.id = q.idPEU;
                    q.valorMin = exibirMoeda(q.valorMin);
                    q.valorMinNumber = q.valorMin;
                    q.checkIn = formatarData(q.checkIn);
                    q.checkOut = formatarData(q.checkOut);

                    if (q.divulgado === 0) {
                      q.divulgado = "Não";
                    } else {
                      if (q.divulgado === 1) {
                        q.divulgado = "Sim";
                      }
                    }
                    return q;
                  } else {
                    return null;
                  }
                });

                if (ArrayChildren.length !== 0) {
                  p.children = ArrayChildren;
                }

                return p;
              } else {
                return null;
              }
            });

            setAluguel(ArrayNovo);
            setIsLoading(false);
          }
        } catch (error) {
          // if (error.response.status === 401) {
          //   logout();
          // }
        }
      }
    };
    fetchToken();
  }, []);

  const getColumnSearchProps = (
    dataIndex: DataIndex
  ): ColumnType<DataType> => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            handleSearch(selectedKeys as string[], confirm, dataIndex)
          }
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() =>
              handleSearch(selectedKeys as string[], confirm, dataIndex)
            }
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 100 }}
          >
            Pesquisar
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Limpar
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText((selectedKeys as string[])[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filtrar
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Fechar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes((value as string).toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const columns: ColumnsType<DataType> = [
    {
      title: "Usuário",
      dataIndex: "nomeUs",
      key: "nome",
      width: "20%",
      ...getColumnSearchProps("nomeUs"),
      sorter: (a, b) => a.nomeUs.length - b.nomeUs.length,
      sortDirections: ["descend", "ascend"],
    },

    {
      title: "Empreendimento",
      dataIndex: "nomeEP",
      key: "nomeEP",
      width: "18%",
      ...getColumnSearchProps("nomeEP"),
    },
    {
      title: "Cota",
      dataIndex: "numeroCota",
      key: "numeroCota",
      width: "12%",
      ...getColumnSearchProps("numeroCota"),
    },
    {
      title: "CheckIn",
      dataIndex: "checkIn",
      key: "checkIn",
      width: "13%",
      ...getColumnSearchProps("checkIn"),
    },
    {
      title: "CheckOut",
      dataIndex: "checkOut",
      key: "checkOut",
      width: "13%",
      ...getColumnSearchProps("checkOut"),
    },
    {
      title: "Divulgado",
      dataIndex: "divulgado",
      key: "divulgado",
      width: "13%",

      filters: [
        { text: "Sim", value: "Sim" },
        { text: "Não", value: "Não" },
      ],
      onFilter: (value: any, record) => record.divulgado.includes(value),
      filterSearch: true,
    },
    {
      title: "Valor Mínimo",
      dataIndex: "valorMin",
      key: "valorMin",
      width: "20%",
      ...getColumnSearchProps("valorMin"),
    },
    {
      title: "Ações",
      dataIndex: "operation",
      key: "operation",
      render: (item, row) => (
        <Space size="middle">
          <Dropdown menu={{ items, onClick }} trigger={["click"]}>
            <BotoesAcoes
              onClick={() => {
                divulgado.current = row.divulgado;
                periodoUsuario.current = row.idPEU;
                userId.current = row.idUs;
                periodo.current = row.idPE;
                valor.current = row.valorMin;
                cotaUsuarioId.current = row.idCTU;
                fracionamento.current = row.fracionamento;
                checkInPeriodo.current = row.checkIn;
                checkOutPeriodo.current = row.checkOut;
                nomeEP.current = row.nomeEP;
              }}
            >
              <Space>
                <SettingsIcon />
              </Space>
            </BotoesAcoes>
          </Dropdown>
        </Space>
      ),
    },
  ];
  const onChange: TableProps<DataType>["onChange"] = (
    pagination,
    filters,
    sorter,
    extra
  ) => {
    console.log("params", pagination, filters, sorter, extra);
  };

  //PERÍODOS FRACIONADOS
  const criarPeriodosFracionados = async (valuesFracao: any) => {
    const Token = validateToken();

    if (valuesFracao.checkIn1 === undefined) {
      valuesFracao.checkIn1 = checkInPeriodo.current;
    }
    if (valuesFracao.checkOut1 === undefined) {
      valuesFracao.checkOut1 = sugestaoCheckOut;
    }
    if (valuesFracao.checkIn2 === undefined) {
      valuesFracao.checkIn2 = sugestaoCheckOut;
    }
    if (valuesFracao.checkOut2 === undefined) {
      valuesFracao.checkOut2 = checkOutPeriodo.current;
    }
    const valorMin = valor.current;

    if (Token) {
      const URLPeriodoGet = `${Globais.DOMINIOBACK}/periodo/${periodo.current}`;

      try {
        const responsePeriodoGet = await axios.get(URLPeriodoGet, {
          headers: { Authorization: Token.AuthStr },
        });
        if (responsePeriodoGet) {
          const URLPeriodo = `${Globais.DOMINIOBACK}/periodo/`;
          let formDataPeriodo1 = {
            cotaId: responsePeriodoGet.data.cotaId,
            checkIn: AlterarFormatoData(valuesFracao.checkIn1),
            checkOut: AlterarFormatoData(valuesFracao.checkOut1),

            origem: Token.id,
          };
          try {
            const responseCriarPeriodo1 = await axios.post(
              URLPeriodo,
              formDataPeriodo1,
              {
                headers: { Authorization: Token.AuthStr },
              }
            );
            if (responseCriarPeriodo1) {
              const URLPeriodoUsuario = `${Globais.DOMINIOBACK}/periodo-usuario/`;
              let formDataPeriodoUsuario1 = {
                alugar: 1,
                trocar: 0,
                concluido: 0,
                utilizar: 0,
                valorMin: valuesFracao.valorMin1,
                periodoId: responseCriarPeriodo1.data.id,
                cotasUsuariosId: cotaUsuarioId.current,
                fracionamento: periodoUsuario.current,
              };
              const responseCriarPeriodoUsuario1 = await axios.post(
                URLPeriodoUsuario,
                formDataPeriodoUsuario1,
                {
                  headers: { Authorization: Token.AuthStr },
                }
              );

              if (responseCriarPeriodoUsuario1) {
                let formDataPeriodo2 = {
                  cotaId: responsePeriodoGet.data.cotaId,
                  checkIn: AlterarFormatoData(valuesFracao.checkIn2),
                  checkOut: AlterarFormatoData(valuesFracao.checkOut2),

                  origem: Token.id,
                };
                try {
                  const responseCriarPeriodo2 = await axios.post(
                    URLPeriodo,
                    formDataPeriodo2,
                    {
                      headers: { Authorization: Token.AuthStr },
                    }
                  );
                  if (responseCriarPeriodo2) {
                    let formDataPeriodoUsuario2 = {
                      alugar: 1,
                      trocar: 0,
                      concluido: 0,
                      utilizar: 0,
                      valorMin: valuesFracao.valorMin2,
                      periodoId: responseCriarPeriodo2.data.id,
                      cotasUsuariosId: cotaUsuarioId.current,
                      fracionamento: periodoUsuario.current,
                    };
                    try {
                      const responseCriarPeriodoUsuario2 = await axios.post(
                        URLPeriodoUsuario,
                        formDataPeriodoUsuario2,
                        {
                          headers: { Authorization: Token.AuthStr },
                        }
                      );
                      if (responseCriarPeriodoUsuario2) {
                        success("Período fracionado com sucesso!");
                        setTimeout(() => {
                          document.location.reload();
                        }, 2000);
                      } else {
                        error("Algo deu errado!");
                      }
                    } catch (error) {
                      console.log(
                        "Não foi possível criar o segundo período do usuário"
                      );
                      error("Algo deu errado!");
                    }
                  }
                } catch (error) {
                  console.log("Não foi possível criar o segundo período");
                  error("Algo deu errado!");
                }
              }
            }
          } catch (error) {
            console.log("Não foi possível criar a fração de período");
            error("Algo deu errado!");
          }
        }
      } catch (error) {
        console.log("Não foi possível saber qual período pai.");
        error("Algo deu errado!");
      }
    }
  };

  return (
    <>
      {isLoading ? (
        <Skeleton active />
      ) : (
        <Container>
          <ContainerFiltro>
            {contextHolder}
            <AttachMoneyIcon color="primary" fontSize="large" />
            <h1>Gerenciar aluguéis</h1>
          </ContainerFiltro>
          <ContainerLista>
            {/*lista de períodos a alugar*/}
            <Table
              columns={columns}
              dataSource={Aluguel}
              onChange={onChange}
              bordered
            />
            <CollectionCreateFormFracao
              open={openFracao}
              onCreate={async function (
                valuesFracao: ValuesFracao
              ): Promise<void> {
                criarPeriodosFracionados(valuesFracao);
              }}
              onCancel={function (): void {
                setOpenFracao(false);
              }}
            />
            <CollectionCreateFormValores
              open={openValores}
              onCreate={async function (
                valuesFracao: ValuesFracao
              ): Promise<void> {}}
              onCancel={function (): void {
                setOpenValores(false);
              }}
            />
            {/*modal de exclusão*/}
            <Modal
              title="Tem certeza que deseja excluir?"
              open={openExcluir}
              onOk={excluirPeriodo}
              onCancel={hideModal}
              okText="Sim, quero excluir"
              cancelText="Não"
            >
              <p>
                Essa ação não poderá ser desfeita. Será necessário criar outro
                período.
              </p>
            </Modal>
            {/*modal para inclusão de valor sem fração*/}
            <CollectionCreateFormValor
              open={openValor}
              onCreate={async function (
                valuesValor: ValuesValor
              ): Promise<void> {
                valor.current = valuesValor.valorMin;
                if (emLote.current === 0) {
                  atualizarValorAluguel(
                    periodoUsuario.current,
                    alugarOuTrocar.current
                  );
                } else {
                  if (emLote.current === 1) {
                    atualizarValorAluguelEmLote(
                      periodoUsuario.current,
                      alugarOuTrocar.current
                    );
                  }
                }
              }}
              onCancel={function (): void {
                setOpenValor(false);
              }}
            />

            {/*modal para envio de email*/}
            <CollectionCreateForm
              open={open}
              onCreate={async function (values: Values): Promise<void> {
                // console.log(values);
                let resposta = enviarEmail({
                  userId: userId.current,
                  tipoEmail: 1,
                  subjectEmail: values.title,
                  bodyEmail: values.description,
                });
                if (await resposta) {
                  setOpen(false);
                  success("Mensagem enviada com sucesso!");
                } else {
                  error("Algo deu errado!");
                }
              }}
              onCancel={function (): void {
                setOpen(false);
              }}
            />
          </ContainerLista>
        </Container>
      )}
    </>
  );
}
